import FormFunc from "utils/FormFunc";
import UploadAPI from "utils/Upload.API";


const EditInfo = () => {
  window.location.href = `/employees/myprofile/?tab=edit`;
};
const SaveInfo = (data, setData, saveData, setSaveData) => {
  if (data?.isSaving) {
    return;
  }
  const checked = FormFunc.CheckedRequired(data);
  if (!checked) {
    // console.log("checked requires=>" + checked);
    return;
  }
  if (Object.keys(saveData).length === 0) {
    return;
  }
  setData({ ...data, isSaving: true });
  //console.log("save=>", saveData);
  // return;
  let formData = new FormData();
  formData.append("userID", window.$user_profile.idu);
  formData.append("userEmail", window.$user_profile.emailadd);
  formData.append("staffID", data?.idu ?? 0);
  const payloadSaveData = { ...saveData };
  const files = payloadSaveData?.photo ?? [];
  if (files.length > 0) {
    for (var i = 0; i < files.length; i++) {
      formData.append("photo[]", files[i], files[i]["name"]);
    }
    delete payloadSaveData.photo;
  }
  formData.append("saveData", JSON.stringify(payloadSaveData));
  const mainFunc = async () => await UploadAPI.post("info/user/save", formData);
  mainFunc()
    .then((res) => {
      const decrypt = (res?.data);
      // console.log("info user save=", decrypt);
      if (decrypt?.status === "success" && decrypt?.data) {
        setSaveData({});
        setData({ ...decrypt.data?.staffDetail, isSaving: false, err: 0 });
      } else {
        setData({
          ...data,
          isSaving: false,
          err: 1,
          err_msg: decrypt?.err_msg ?? "",
        });
      }
    })
    .catch((err) => {
      console.log(err);
      setData({ ...data, isSaving: false, err: 1, err_msg: `Failes : ${err}` });
    });
};

const SelectChangeInfo = (
  evt,
  { id, name, value },
  filterData,
  data,
  setData,
  saveData,
  setSaveData
) => {
  // console.log(evt); //return;
  let saveValue;
  const tmp = { ...data };
  if (name === "country") {
    const countryData = filterData.countries.find(
      (item) => item.country_code === value
    );
    const country_name = countryData?.country_name ?? "";
    saveValue = country_name;
  } else if (name === "work_country") {
    const countryData = filterData.workcountries.find(
      (item) => item.country_code === value
    );
    const country_name = countryData?.country_name ?? "";
    saveValue = country_name;
  }
  tmp[name] = value;
  if (["country", "work_country"].includes(name)) {
    tmp.key_form = Math.random();
  }
  setData(tmp);
  // console.log("filters=", tmp);
  // console.log("name=", name);
  // console.log("value=", value);
  const tmpSave = { ...saveData };
  if (name === "contact_country") {
    tmpSave["contact_country"] = value;
  } else {
    tmpSave[name] = saveValue ?? value;
  }
  // console.log("tmpSave=", tmpSave);
  setSaveData(tmpSave);
};

const ChangeInfo = (evt, data, setData, saveData, setSaveData) => {
  // console.log(evt);//return;
  let name = evt.target.name;
  let value = evt.target.value;
  // console.log("name=", name, value, evt.target.id);
  let saveValue;
  const tmp = { ...data };
  if (name === "photo") {
    const fileList = evt.target.files;
    let files = [];
    if (fileList) {
      const n = fileList.length;
      for (let i = 0; i < n; i++) {
        fileList[i].data_url = URL.createObjectURL(fileList[i]);
      }
      files = [...fileList];
    }
    value = [...files];
  }
  tmp[name] = value;
  setData(tmp);
  // console.log("On change=", tmp);
  const tmpSave = { ...saveData };
  tmpSave[name] = saveValue ?? value;
  setSaveData(tmpSave);
};

export { EditInfo, SaveInfo, SelectChangeInfo, ChangeInfo };

